import React, { useEffect } from "react"
import { motion } from "framer-motion"
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa"

export default function Lightbox({
  images = [],
  currentIndex,
  setCurrentIndex,
  onClose,
}) {
  const isOpen = currentIndex !== null && currentIndex !== undefined

  const closeLightbox = () => {
    setCurrentIndex(null)
    if (onClose) onClose()
  }

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    )
  }

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    )
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return

      if (e.key === "Escape") closeLightbox()
      if (e.key === "ArrowRight") nextImage()
      if (e.key === "ArrowLeft") prevImage()
    }

    window.addEventListener("keydown", handleKeyDown)
    document.body.style.overflow = isOpen ? "hidden" : "auto"

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
      document.body.style.overflow = "auto"
    }
  }, [isOpen])

  if (!isOpen) return null

  const currentImage = images[currentIndex]

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90">
      {/* Close Button */}
      <button
        onClick={closeLightbox}
        className="absolute top-6 right-6 text-white text-2xl hover:text-[#b8955d]"
        aria-label="Close lightbox"
      >
        <FaTimes />
      </button>

      {/* Prev Button */}
      <button
        onClick={prevImage}
        className="absolute left-6 text-white text-3xl hover:text-[#b8955d]"
        aria-label="Previous image"
      >
        <FaChevronLeft />
      </button>

      {/* Next Button */}
      <button
        onClick={nextImage}
        className="absolute right-6 text-white text-3xl hover:text-[#b8955d]"
        aria-label="Image suivante"
      >
        <FaChevronRight />
      </button>

      {/* Image */}
      <motion.img
        key={currentImage?.src}
        src={currentImage?.src}
        alt={currentImage?.title || "Spa image"}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="max-h-[85vh] max-w-[90vw] rounded-2xl shadow-2xl object-contain"
      />

      {/* Caption */}
      <div className="absolute bottom-8 text-center text-white">
        <h3 className="text-lg font-semibold">
          {currentImage?.title}
        </h3>

        <p className="text-sm text-gray-300 mt-1">
          Galerie du Spa
        </p>
      </div>
    </div>
  )
}